import { HashedUrl } from 'core/infra/HashedUrl'

import { isPortalLinkPath } from '../ui/PortalLinkRoute'

export function isOnPortalLinkRoute(): boolean {
  return isPortalLinkPath(HashedUrl.fromCurrentHref().pathname)
}
